import React from 'react';
import GameOptionButton from './game-option-button';

export default class GameOptions extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  render() {

    return(
      <div className="hidden-picture__options">
        <div className="hidden-picture__reset-button"
          onClick={this.props.resetAction}>
          Reset
        </div>
        <div className="hidden-picture__options-heading">
          Math Area
        </div>
        <div className="hidden-picture__options-panel">
          <GameOptionButton button="addition"
            current={this.props.gameType} action={this.props.chooseType} />
          <GameOptionButton button="subtraction"
            current={this.props.gameType} action={this.props.chooseType} />
          <GameOptionButton button="multiplication"
            current={this.props.gameType} action={this.props.chooseType} />
          <GameOptionButton button="division"
            current={this.props.gameType} action={this.props.chooseType} />
          <GameOptionButton button="geometry"
            current={this.props.gameType} action={this.props.chooseType} />
        </div>
        <div className="hidden-picture__options-heading">
          Solve for
        </div>
        <div className="hidden-picture__options-panel">
          <GameOptionButton button="problem"
            current={this.props.gameDisplay} action={this.props.chooseDisplay} />
          <GameOptionButton button="answer"
            current={this.props.gameDisplay} action={this.props.chooseDisplay} />
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/hidden-picture/game-options.js
 **/